import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { emptySlot, Slot, terminalType } from 'icreate/common/models/slot';

import { terminalTitles, terminalSides, doRelayTitles } from '@components/system-setting/slot-dialog/constant';

@Injectable({
    providedIn: 'root',
})
export class SlotDisplayService {
    constructor(private translateService: TranslateService) {}

    private translate(key?: string): string {
        return key ? this.translateService.instant(key) : '';
    }

    getSlotValue(slot: Slot): string {
        const { terminal, ioType } = slot;

        if (!terminal?.length) {
            return '';
        }

        switch (ioType) {
            case 'DO':
                return terminal
                    .sort((a, b) => a.index - b.index)
                    .map(t => {
                        const titleKey =
                            t.type === terminalType.relay && t.doRelayType
                                ? doRelayTitles[t.doRelayType]
                                : terminalTitles[t.type];

                        return this.translate(titleKey) + ' ' + (t.num ?? '') + this.translate(terminalSides[t.side]);
                    })
                    .join('+');

            case 'DI': {
                const descriptionKeys = [
                    'system-settings.di-slot.first.description',
                    'system-settings.di-slot.second.description',
                ];

                return terminal
                    .sort((a, b) => a.index - b.index)
                    .map(t => this.translate(descriptionKeys[t.index]) + ' ' + this.translate(terminalSides[t.side]))
                    .join(' · ');
            }

            case emptySlot:
                return '';

            default:
                return this.translate(terminalSides[terminal[0]?.side]);
        }
    }
}
